import * as React from "react";
import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import axiosConfig from "./utils/axiosConfig";
import HeaderSubPage from "./partial/HeaderSubPage";
import {ToastContainer} from "react-toastify";
import {notify} from "./utils/utils";

export default function NewsletterConfirm({partner}) {
    const [searchParams] = useSearchParams();
    const newsletterId = searchParams.get("id");
    const token = searchParams.get("token");
    const [status, setStatus] = useState(null);

    const doConfirm = async () => {
        try {
            const response = await axiosConfig.get(`/newsletter/confirmation?id=${newsletterId}&token=${token}`);
            setStatus(response.status)
        } catch (error) {
            notify("Der Newsletter-Link ist ungültig oder der Newsletter existiert nicht mehr.")
            throw error
        }
    }

    useEffect(() => {
        doConfirm()
        document.title = `${partner?.name} - Newsletter Bestätigung`;
    }, [partner]);
    return (
        <div>
            <ToastContainer/>
            <div className="site wrapper-content">
                <HeaderSubPage title={'Newsletter Bestätigung'}></HeaderSubPage>
                <section className="content-area">
                    <div className="container">
                        <div className="row">
                            <div className="site-main col-sm-12">
                                <h1>
                                    Newsletter Bestätigung
                                </h1>
                                {status === 200 ?
                                    (
                                        <p>
                                            Vielen Dank für Ihre Anmeldung zu unserem Newsletter!
                                        </p>
                                    ) : (
                                        <p>
                                            Der Newsletter-Link ist ungültig oder der Newsletter existiert nicht mehr.
                                        </p>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
